
export class WpNonCompliance {
    constructor(
        public id?: number,
        public referralId?: number,
        public personId?: number,
        public nonCoopDiscoveryDt?: any,
        public nonCoopMonthDt?: any,
        public nonComplianceReasonCd?: string,
        public programCd?: string,
        public goodCauseRequestedSw?: string,
        public goodCauseAuthorizedCd?: string,
        public nonComplianceNotes?: string,


        public grantGoodCauseCd?: string,
        public goodCauseGrantedDt?: any,
        public goodCauseNotes?: string,

        public wpEtEnrollmentId?:number,
        public inCompliance?: string,
        public complianceDate?: any,

/*        public caseNum?: string,
        public sanctionStatus?: string,
        public nonCoopEndDt?: any,
        public goodCauseSw?: string,
        public goodCauseDesc?: string,
        public goodCauseReasonCd?: string,
        public goodCauseVerificationCd?: string,
        public goodCauseDueDt?: any,
        public concilliationCompleteSw?: string,
        public concilliationCompletionDt?: any,*/

    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-non-compliance.model.ts